export const sequence = {
    sequence_empty_list: 'No hay cuestionarios disponibles para este período de tiempo.',
    sequence_list_summary_one: '{{count}} cuestionario por completar',
    sequence_list_summary_many: '{{count}} cuestionarios por completar',
    sequence_list_summary_other: '{{count}} cuestionarios por completar',
    sequence_empty_title: 'Todo al día',
    sequence_empty_text: 'No hay cuestionarios por completar por ahora.',
    sequence_next_label: 'Próximo:',
};
